import { useRef } from 'react';

import { useCopy } from '@/copy';

export interface IDisplayHeading {
    title: string;
    subtitle?: string;
    infoText?: string;
}

function DisplayHeading({
    title,
    infoText,
    subtitle,
}: IDisplayHeading): JSX.Element {
    const headingRef = useRef<HTMLDivElement>(null);
    const { leftAlignHeading } = useCopy();

    return (
        // pb-3 separates the heading from whatever the screen puts below it.
        // The subtitle used to provide that gap by accident, so removing it
        // left every screen's first card sitting against the paragraph.
        <div className='pb-3'>
            <div
                ref={headingRef}
                className={`pt-2 w-full _flex items-center justify-between  relative`}
            >
                <div />

                <div
                    className={`w-full flex flex-col justify-center ${
                        leftAlignHeading
                            ? 'items-start text-left'
                            : 'items-center text-center'
                    }`}
                >
                    <h3 className='fieldHeading text-lg font-bold text-[#201C1F]'>
                        {title}
                    </h3>
                    {infoText && (
                        <p className='text-sm mt-1 max-w-md'>{infoText}</p>
                    )}
                </div>
            </div>
            {subtitle && (
                <div
                    className={`mt-1 text-xs font-semibold text-textBody ${
                        leftAlignHeading ? 'text-left' : 'text-center'
                    }`}
                >
                    {subtitle}
                </div>
            )}
        </div>
    );
}

export { DisplayHeading };
